export enum Domain {
  MetadataMonitoring = 'MetadataMonitoring',
  BusinessProcess = 'BusinessProcess',
}
